export const WITHDRAW_MIN_AMOUNT = 500;
export const WITHDRAW_MIN_AMOUNT_USD = 1000;
